module.exports = __webpack_public_path__ + "static/media/pix.e896240b.svg";